import { gql } from '@apollo/client';

export const GET_CURRENT_COMPANY_LLM_BUDGET_OVERVIEW = gql`
  query GetCurrentCompanyLlmBudgetOverview {
    currentCompanyLlmBudgetOverview {
      usagePercentage
      enforcementEnabled
      capReached
    }
  }
`;
